export const environment = {
  production: true,
  apiUrl: 'https://api.gaspre.mx',
  developmentUrl: 'http://localhost:80',
  notificationVapidPublicKey: 'BPFXawZ4KaRQqMSuicebOFQjpPwbpG0Sgo2pTS_TnrMYjiz08NOi-5Bozl3tzbQ05MEGa7V4Do1TLD_4cFs-nMg'
};
